module.exports = __webpack_public_path__ + "img/curs.34ae4db8.png";